/**
 * Persists a standalone consent choice (no beverage category data attached)
 * via the same save-beverage-preferences action every other beverage flow's
 * consent handling uses. sessionStorage is intentionally NOT written until
 * this resolves without throwing, so a failed save can't leave the session
 * believing consent was recorded when CDP never received it.
 */
export const saveBeverageV3ConsentOnly = async ({
  acid,
  optedOut,
  actionWebInvoke,
  actionUrl,
  logger = console,
}) => {
  if (!acid) {
    return false;
  }

  try {
    await actionWebInvoke(actionUrl, {}, { acid, optedOutPersonalization: optedOut });
    return true;
  } catch (error) {
    logger.error("Error saving consent:", error);
    return false;
  }
};
